"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiButton = getMuiButton;
exports.getMuiButtonBase = getMuiButtonBase;
function getMuiButtonBase() {
  return {
    defaultProps: {
      disableRipple: true,
      disableTouchRipple: true,
      focusRipple: false
    }
  };
}
function getMuiButton(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required',
      disableElevation: true
    },
    styleOverrides: {
      contained: {
        '&:hover,&._hover': {
          background: palette.primary.dark
        }
      },
      outlined: {
        '&.Mui-disabled': {
          background: palette.grey[100],
          color: palette.divider
        }
      },
      root: {
        '&:focus,&._focus': {
          outline: "1px solid ".concat(palette.primary.main),
          outlineOffset: '1px'
        },
        boxSizing: 'border-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      },
      sizeLarge: {
        fontSize: 18,
        height: 56,
        padding: '16px'
      },
      sizeMedium: {
        height: 40,
        padding: '8px 16px'
      },
      sizeSmall: {
        fontSize: 16,
        height: 30,
        lineHeight: '24px',
        padding: '3px 12px'
      },
      text: {
        '&.Mui-disabled': {
          background: palette.grey[100],
          border: "1px solid ".concat(palette.grey[300]),
          color: palette.grey[300]
        },
        '&:hover,&._hover': {
          background: palette.primary.light
        }
      }
    },
    variants: [{
      props: {
        variant: 'newContained'
      },
      style: {
        '& .MuiSvgIcon-root': {
          height: '18px',
          width: '18px'
        },
        '&.Mui-disabled': {
          background: palette.grey[50],
          border: "1px solid ".concat(palette.divider),
          color: palette.divider
        },
        '&:focus': {
          background: palette.primary.dark,
          boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.05), 0px 0px 0px 4px rgba(24, 75, 157, 0.05)',
          outline: 'none'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            minWidth: '64px',
            width: 'auto'
          },
          '&:has(.MuiButton-startIcon)': {
            minWidth: '64px',
            width: 'auto'
          },
          minWidth: '32px',
          width: '42px'
        },
        '&:hover': {
          background: palette.primary.dark
        },
        background: palette.primary.main,
        borderRadius: '4px',
        boxSizing: 'border-box',
        color: palette.common.white,
        fontSize: '14px',
        fontWeight: 400,
        height: 32,
        lineHeight: '22px',
        overflow: 'hidden',
        padding: '5px 12px',
        textOverflow: 'ellipsis',
        textTransform: 'inherit',
        whiteSpace: 'nowrap'
      }
    }, {
      props: {
        variant: 'newOutlined'
      },
      style: {
        '& .MuiSvgIcon-root': {
          height: '18px',
          width: '18px'
        },
        '&.Mui-disabled': {
          background: palette.common.white,
          border: "1px solid ".concat(palette.divider),
          color: palette.divider
        },
        '&:focus': {
          background: palette.grey[50],
          borderColor: palette.divider,
          boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.05), 0px 0px 0px 4px rgba(24, 75, 157, 0.05)',
          outline: 'none'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            minWidth: '64px',
            width: 'auto'
          },
          '&:has(.MuiButton-startIcon)': {
            minWidth: '64px',
            width: 'auto'
          },
          minWidth: '32px',
          width: '42px'
        },
        '&:hover': {
          background: palette.grey[50],
          borderColor: palette.divider
        },
        border: "1px solid ".concat(palette.divider),
        borderRadius: '4px',
        boxSizing: 'border-box',
        color: palette.primary.main,
        fontSize: '14px',
        fontWeight: 400,
        height: 32,
        lineHeight: '22px',
        overflow: 'hidden',
        padding: '5px 12px',
        textOverflow: 'ellipsis',
        textTransform: 'inherit',
        whiteSpace: 'nowrap'
      }
    }, {
      props: {
        variant: 'newRoot'
      },
      style: {
        '& .MuiSvgIcon-root': {
          height: '18px',
          width: '18px'
        },
        '&.Mui-disabled': {
          background: palette.grey[50],
          border: "1px solid ".concat(palette.divider),
          color: palette.divider
        },
        '&:focus': {
          background: palette.primary.dark,
          boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.05), 0px 0px 0px 4px rgba(24, 75, 157, 0.05)',
          outline: 'none'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            minWidth: '64px',
            width: 'auto'
          },
          '&:has(.MuiButton-startIcon)': {
            minWidth: '64px',
            width: 'auto'
          },
          minWidth: '32px',
          width: '42px'
        },
        '&:hover': {
          background: palette.primary.dark
        },
        borderRadius: '4px',
        boxSizing: 'border-box',
        color: palette.common.black,
        fontSize: '14px',
        fontWeight: 400,
        height: 32,
        lineHeight: '22px',
        overflow: 'hidden',
        padding: '5px 12px',
        textOverflow: 'ellipsis',
        textTransform: 'inherit',
        whiteSpace: 'nowrap'
      }
    }, {
      props: {
        variant: 'newText'
      },
      style: {
        '& .MuiSvgIcon-root': {
          height: '18px',
          width: '18px'
        },
        '&.Mui-disabled': {
          background: palette.common.white,
          borderColor: palette.common.white,
          color: palette.divider
        },
        '&:focus': {
          background: palette.grey[50],
          boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.05), 0px 0px 0px 4px rgba(24, 75, 157, 0.05)',
          color: palette.primary.main,
          outline: 'none'
        },
        '&:has(.MuiSvgIcon-root)': {
          '&:has(.MuiButton-endIcon)': {
            minWidth: '64px',
            width: 'auto'
          },
          '&:has(.MuiButton-startIcon)': {
            minWidth: '64px',
            width: 'auto'
          },
          minWidth: '32px',
          width: '42px'
        },
        '&:hover': {
          background: palette.grey[50],
          color: palette.primary.main
        },
        borderRadius: '4px',
        boxSizing: 'border-box',
        color: palette.primary.main,
        fontSize: '14px',
        fontWeight: 400,
        height: 32,
        lineHeight: '22px',
        overflow: 'hidden',
        padding: '7px 12px',
        textOverflow: 'ellipsis',
        textTransform: 'inherit',
        whiteSpace: 'nowrap'
      }
    }]
  };
}